<div class="absolute right-0 z-50 mt-3 w-[90vw] max-w-xs rounded-xl shadow-lg border border-white/10 backdrop-blur-md transition-all duration-300 ease-in-out"
     [ngClass]="isDarkMode() ? 'bg-gray-900/80 text-white' : 'bg-white/80 text-gray-800'"
     #settingsMenuRef>

  <!-- 🌐 Langue -->
  <div class="px-4 pt-4">
    <label class="text-sm font-semibold"
           [ngClass]="mode === 'bridge' ? 'text-blue-300' : 'text-purple-300'">
      🌍 {{ 'LANGUAGE' | translate }}
    </label>

    <select [(ngModel)]="selectedLanguage"
            (change)="changeLanguage(selectedLanguage)"
            class="w-full mt-2 p-3 rounded-lg bg-white/10 dark:bg-gray-700 border text-sm shadow-inner focus:outline-none focus:ring-2"
            [ngClass]="mode === 'bridge'
              ? 'border-blue-500 focus:ring-blue-500'
              : 'border-purple-500 focus:ring-purple-500'">
      <option *ngFor="let lang of languages" [value]="lang.code">
        {{ lang.label }}
      </option>
    </select>
  </div>

  <!-- 💱 Devise -->
  <div class="px-4 pt-4 pb-6">
    <label class="text-sm font-semibold"
           [ngClass]="mode === 'bridge' ? 'text-blue-300' : 'text-purple-300'">
      💱 {{ 'CURRENCY' | translate }}
    </label>

    <select [(ngModel)]="selectedCurrency"
            (change)="changeCurrency(selectedCurrency)"
            class="w-full mt-2 p-3 rounded-lg bg-white/10 dark:bg-gray-700 border text-sm shadow-inner focus:outline-none focus:ring-2"
            [ngClass]="mode === 'bridge'
              ? 'border-blue-500 focus:ring-blue-500'
              : 'border-purple-500 focus:ring-purple-500'">
      <option *ngFor="let currency of currencies" [value]="currency">
        {{ getCurrencyLabel(currency) }}
      </option>
    </select>
  </div>
</div>
